<template>
  <div class="content-b" v-if="material && material.length > 0">
    <div class="content-title">
      <img
        src="https://img.esenyun.com/images/20200710/f4e7f9154c0b4972929e248c152ddf2d.png"
      />
    </div>
    <div style="padding:0 16px;" v-for="item in material" :key="item.id">
      <materialCard
        :item="item"
        @link="linkDetail(item)"
      />
    </div>
  </div>
</template>

<script>
import materialCard from '../components/materialCard'
import env from '../config/env'
export default {
  components: {
    materialCard,
  },
  props: {
    activityId: {
      type: String,
      default: '',
    },
    shareId: {
      type: String,
      default: '',
    },
    vcardData:{
      type: Object,
      default: ()=>{
        return {}
      },
    }
  },
  data() {
    return {
      material: [],
      multiChannelId:env.AJNmultiChannelId,//艾锦囊多渠道id
    }
  },
  mounted() {
    console.log('mounted')
    this.getList()
  },
  methods: {
    getList() {
          console.log('getList')
      this.$http
        .get(
          `aocampaign/openapi/activity/contentRel/${this.activityId}?shareId=${this.shareId}`
        )
        .then(async (res) => {
          console.log('res', res.data)
          res.data.forEach(async (item) => {
            item.id = item.contentId
            item.is_top = item.isTop
            item.type = +item.type
            item.audit_date = item.auditDate
            item.display_type = item.displayType
            if (item.type === 3) {
              if(item.url) {
                item.videoUrl = item.url
              } else {
                item.videoUrl = await this.getData(item.id)
              }
            }
          })
          // for (let index = 0; index < res.data.length; index++) {
          //   const item = res.data[index]
          //   item.id = item.contentId
          //   item.is_top = item.isTop
          //   item.type = +item.type
          //   item.audit_date = item.auditDate
          //   item.display_type = item.displayType
          //   if (item.type === 3) {
          //     item.videoUrl = await this.getData(item.id)
          //   }
          // }
          this.material = res.data
          console.log('material--res', this.material)
        })
    },
    getData(id) {
      return new Promise((s) => {
        const formData = new FormData()
        formData.append('materialId', id)
        this.$http(env.materialUrl + 'cfsite/material/detail', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          // mode: 'cors',
          data: formData,
        }).then((res) => {
          console.log('res-getData', res)
          const src = res.data && res.data.model ? this.praseVideoUrl(res.data.model.content) : ''
          console.log('src-url', src)
          s(src)
        })
      })
    },
    praseVideoUrl(content) {
      let url = ''
      content.replace(/<object\b[^<>]*>.*?<\/object>/gi, function(match) {
        match = match.replace(
          'http://material.aosmith',
          'https://material.aosmith'
        )
        const start = match.indexOf('https://material.aosmith')
        const upEnd = match.indexOf('MP4')
        const end = match.toLocaleLowerCase().indexOf('mp4')
        const videoUrl =
          match.slice(start, end) + (upEnd !== -1 ? 'MP4' : 'mp4')
        url = videoUrl
        return `${videoUrl}`
      })
      return url
    },
    linkDetail(item) {
      let vcardDatas=`${encodeURIComponent(JSON.stringify(this.vcardData))}`
      this.$router.push(`material?id=${item.id}&vcardData=${vcardDatas}&multiChannelId=${this.multiChannelId}`)
      // uni.navigateTo({
      //   url: `/pages/materialDetail?id=${item.id}`,
      // })
    },
  },
}
</script>

<style lang="less" scoped>
.content-b {
  background: #fff;
  padding-top: 16px;
  border-top: 8px solid #f7f8fa;
}
.content-title {
  text-align: center;
  img {
    display: inline-block;
    width: 144px;
    height: 22px;
  }
}
</style>
